import React from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  email: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export class SignUpFormEmail extends React.Component<Props> {
  render() {
    return (
      <label htmlFor="input-email" className="signup-form__label">
        <FormattedMessage id="signup/routes/user/form/SignUpFormEmail.tsx/1" />
        <input
          id="input-email"
          data-test-id="input-email"
          type="text"
          name="email"
          value={this.props.email}
          onChange={this.props.handleChange}
          spellCheck={false}
          autoComplete="email"
          required
        />
      </label>
    );
  }
}
